import { Timestamp } from '@bufbuild/protobuf/wkt'
import { CircleIcon, DotIcon, XIcon } from 'lucide-react'
import { ReactNode } from 'react'

import { DocumentError } from '@/gen/artifacts/v1/model_pb'

import { DocumentStatus } from '@/const/artifact-status.types'
import { documentStatusLabel } from '@/const/label'

import { TIMELINE_STATUSES } from '@/components/shared/document-status-badge/consts'
import { TimelineItem } from '@/components/shared/document-status-badge/timeline-item'

const TIMELINE_DOTS = {
  gray: <DotIcon strokeWidth={18} size={7} className='text-main-foreground-disabled' />,
  green: <CircleIcon strokeWidth={5} className='size-1.5 text-main-foreground-success' />,
  red: <XIcon className='size-2.5 text-main-foreground-danger' />,
  purple: <DotIcon strokeWidth={18} size={7} className='text-main-foreground-accent' />,
} as const

const getTimelineDot = (
  status: DocumentStatus,
  currentStatus: DocumentStatus,
  error?: DocumentError,
): ReactNode => {
  const statusIndex = TIMELINE_STATUSES.indexOf(status)
  const currentIndex = TIMELINE_STATUSES.indexOf(currentStatus)
  const isBeforeCurrent = statusIndex < currentIndex
  const isCurrent = status === currentStatus

  if (error) {
    if (status === DocumentStatus.PENDING) return TIMELINE_DOTS.green
    if (status === DocumentStatus.CLASSIFYING) return TIMELINE_DOTS.red
    return TIMELINE_DOTS.gray
  }

  if (isCurrent) {
    return status === DocumentStatus.COMPLETE ? TIMELINE_DOTS.green : TIMELINE_DOTS.purple
  }

  return isBeforeCurrent ? TIMELINE_DOTS.green : TIMELINE_DOTS.gray
}

export const getTimelineItems = (
  currentStatus: DocumentStatus,
  error?: DocumentError,
  lastUpdated?: Timestamp,
) => {
  return TIMELINE_STATUSES.map((status) => ({
    children: (
      <TimelineItem
        label={documentStatusLabel[status]}
        showLastUpdated={status === currentStatus && !error}
        lastUpdated={lastUpdated}
      />
    ),
    dot: getTimelineDot(status, currentStatus, error),
  }))
}
